var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ui-view=\"\"><h3><i class=\"fa fa-spin fa-spinner\"></i>&nbsp;Loading...</h3></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/payments/payments.jade
// module id = 753
// module chunks = 0